import './index.css';
import React, { useState, useEffect } from 'react';
import { Card, Grid, Box, Text, Flex } from 'theme-ui';
import { StyledButton } from './styles.js';
import { getAuth, signOut } from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { Link, useLocation, useNavigate } from 'react-router-dom'; /** @jsxRuntime classic */
/** @jsx jsx */ import { jsx } from "theme-ui";
import CIcon from '@coreui/icons-react';
import { cilApplications, cilAddressBook, cilLayers, cilSettings, cilFlower } from '@coreui/icons';
import { useFirebaseProfile } from './useFirebaseProfile';
import { FaLinkedin, FaEnvelope, FaInstagram } from 'react-icons/fa';

const Navbar = (props) => {

  const location = useLocation();
  const { profile } = useFirebaseProfile();
  const [totalEvents, setTotalEvents] = useState(0);

  useEffect(() => {

    const checkCompStatus = async () => {

      if (!profile?.email) return; // if we don't have a profile loaded

      try {

        const functions = getFunctions();
        const getSheetData = httpsCallable(functions, 'getSheetData');

        const result = await getSheetData();
        const countEvents = result.data.totalEvents; // get the number of total events

        console.log(`wahoo fetched ${countEvents} from the current profile`);

        setTotalEvents(countEvents); // update and re-rendere
      } catch (error) {
        console.error('error checking comp status: ', error);
      }
    };

    checkCompStatus();

  }, [profile?.email]); // re-run when profile loads

    var pages = [
      {page: 'Events', icon: cilApplications}, 
      {page: 'Directory', icon: cilAddressBook},
      {page: 'Resources', icon: cilLayers},
      ...(totalEvents >= 1 ? [{page: 'Comp', icon: cilFlower}] : []), // only if curr user is comping
      {page: 'Profile', icon: cilSettings},
    ];
      
    const firstName = profile.displayName 
    ? profile.displayName.split(' ')[0]
    : 'WiCS';


    const [loggedIn, setLoggedIn] = useState(props);
    const auth = getAuth();
    const navigate = useNavigate();

    useEffect(() => {
      setLoggedIn(props);
    }, [props]);

    const handleLogout = () => {
      signOut(auth);
      setLoggedIn(false);
      navigate("/Login");
    }

    const handleClick = (key) => {

      if (key === 'email') {
        window.location.href = `mailto:${'admin@harvardwics.com'}`;
      }

      else if (key === 'linkedin') {
        const linkedinUrl = `https://www.linkedin.com/company/harvard-wics/posts/?feedView=all`;
        window.open(linkedinUrl, '_blank');
      }

      else if (key === 'instagram') {
        const instagramUrl = `https://www.instagram.com/hu.wics/`;
        window.open(instagramUrl, '_blank');
      }

    };

    const iconStyle = {
      align: 'center',
      color: 'white',
      fontSize: '2em',
      padding: '0.2em',
      margin: '0.2em',
      
      '&:hover': {
        color: '#FFFFFF',
        cursor: 'pointer',
      }
      
    };
    
    /* map through pages to create nav items */
    const navItems = pages.map((page) => {

      const current =
        (location.pathname.replace('/', '') === page.page) ||
        (page.page === 'Events' && location.pathname === '/');
    
      return (

        <Link to={page.page} key={page.page} style={{ textDecoration: 'none' }}>
          <Card
            sx={{
              backgroundColor: current ? 'white' : 'transparent',
              color: current ? 'purple' : 'white',
              alignContent: 'left',
              display: 'flex',
              wordWrap: 'break-word',
              padding: 0.6,
              borderRadius: '32px 0px 0px 32px',
              marginLeft: '10%', 
              maxWidth: '100%',
              width: ['0%', '0%', '90%', '90%'],
              textDecoration: 'none',
              fontSize: 18,
              minWidth: 'calc(200px - 10%)', 
            }}
          >
            <div style={{ display: 'inline-flex', alignItems: 'left', marginLeft: '20%', }}>
              <CIcon icon={page.icon} sx={{ width: 45, padding: 10 }} />
              <p>{page.page}</p>
            </div>
          </Card>
        </Link>
      );
    });

  return (

    <Box
      sx={{
        backgroundColor: '#6E4884',
        width: '20%', 
        minWidth: '200px',
        height: '100vh', 
        position: 'fixed',
        left: 0,
        top: 0,
        zIndex: '99',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between', // push "get in touch" to the bottom
      }}
    >
    {loggedIn ? (
      <div style={{display: 'flex', height: '100vh', flexDirection: 'column', alignItems: 'center', flexGrow: 1 }}>
        <div
          style={{
            display: 'flex',
            position: 'relative',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '50px',
          }}
        >

          <div id="user-image"></div> 
          
          <div
            sx={{
              variant: 'fontweights.heading',
              fontSize: '28px',
              fontFamily: 'fonts.heading',
              lineHeight: '22px',
              color: 'white',
            }}
          >
            <p>Hi, {firstName}!</p>
          </div>
          <p></p>
        </div>

        <Grid columns={[1, 1, 1, 1]} style={{ width: '100%' }}>
          <div
            sx={{
              display: ['initial', 'initial', 'initial', 'initial'],
            }}
          >
            <div>
              <br></br>
              <div
                sx={{
                  position: 'sticky',
                  textAlign: 'center',
                  top: '100px',
                  marginTop: '40px',
                  borderRadius: '32px 0px 0px 32px',
                }}
              >
                {navItems}
              </div>
            </div>
          </div>
        </Grid>
        
        <StyledButton className="logout-button" style={{ marginTop: '60%' }} onClick={handleLogout}>
          Log out
        </StyledButton>

        <Box style={{ marginTop: 'auto', paddingBottom: '20px', textAlign: 'center' }}>
          <Text sx={{ fontSize: 1, fontWeight: 'bold', mb: 3, color: 'white', fontStyle: 'italic' }}>
            connect with us!
          </Text>
          <Flex sx={{ flexDirection: 'row', alignItems: 'center' }}>
            <FaEnvelope style={iconStyle} onClick={() => handleClick('email')}/>
            <FaLinkedin style={iconStyle} onClick={() => handleClick('linkedin')}/>
            <FaInstagram style={iconStyle} onClick={() => handleClick('instagram')}/>
          </Flex>
        </Box>
      </div>
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
          <Text sx={{ color: 'white', fontSize: 3 }}>Welcome to WiCS</Text>
        </Box>
      )}
    </Box>
  );
};

export default Navbar;